const __request = require(`../__request/__request_contentType_json`);

// 国际机票后台申请退票
export default (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/flight/international/buyer/white/order/refund',
    data:data
  }

  return __request(pParameter)
}

